import { Spinner } from '../../../spinner/src';
import { Icon } from '../../../icon/src';
import { AwsUi } from '../../../../core/runtime/src';
import { DropdownStatusType } from '../internal';
export default function DropdownFooter(_a) {
    var _b = _a.status, status = _b === void 0 ? DropdownStatusType.FINISHED : _b, isEmpty = _a.isEmpty, emptyText = _a.emptyText, loadingText = _a.loadingText, finishedText = _a.finishedText, errorText = _a.errorText, recoveryText = _a.recoveryText, onRecoveryClick = _a.onRecoveryClick;
    var statusContent = null;
    if (status === DropdownStatusType.LOADING) {
        statusContent = (AwsUi.__createElement("span", { className: "awsui-util-status-inactive" },
            AwsUi.__createElement(Spinner, null),
            " ",
            loadingText));
    }
    else if (status === DropdownStatusType.ERROR) {
        statusContent = (AwsUi.__createElement("span", { className: "awsui-util-status-negative" },
            AwsUi.__createElement(Icon, { name: "status-negative" }),
            " ",
            errorText,
            ' ',
            AwsUi.__createElement("a", { role: "button", tabIndex: "0", className: "awsui-dropdown-recovery-button awsui-internal-link-button", onclick: onRecoveryClick }, recoveryText)));
    }
    else if (isEmpty) {
        statusContent = emptyText;
    }
    else if (status === DropdownStatusType.FINISHED && finishedText) {
        statusContent = finishedText;
    }
    if (statusContent) {
        return AwsUi.__createElement("span", { className: "awsui-dropdown-status" }, statusContent);
    }
    return null;
}
//# sourceMappingURL=dropdown-footer.js.map